import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Nav from "../../components/Nav";
import fetch from "isomorphic-fetch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
} from "react-share";

// import ArtistTapestrySuccess from '../../components/ArtistTapestrySuccess'
// import ArtistGrid from '../../components/ArtistGrid'
// import ArtistModal from '../../components/ArtistModal'
// import compressed from '../../video/compressed.mp4'
// import { Link } from 'react-router-dom'
// import PayButton from '../../components/PayButton'
// import { Elements } from '@stripe/react-stripe-js'
// import { loadStripe } from '@stripe/stripe-js'
// import CheckoutForm from '../../components/CheckoutForm'
const queryString = require("query-string");
// const stripePromise = loadStripe('pk_live_51Hm3AYEle5f5egjw5R8esKApXYNsGHWZFPadw0zN2eqjR96t4FZ6OJ77VUumIGOTWnBq0GU7cL4GwmT7kuv2QJ9K003tHe6tGt')

class Success extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tickets: null,
    };
  }

  componentDidMount() {
    const ps = queryString.parse(this.props.location.search);
    const sessionId = ps.session_id;

    const url = `https://2tjkrkn7p7.execute-api.eu-west-1.amazonaws.com/dev/tickets?session=${sessionId}`;

    setTimeout(() => {
      fetch(url, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((response) => {
          this.setState({ tickets: response.tickets });
        })
        .catch((err) => {
          console.log(err);
        });
    }, 2000);
  }

  render() {
    return (
      <div>
        <div className="container mx-auto pt-8 pb-8">
          <Nav />
        </div>
        <div className="bg-upton-100 pt-8 pb-8">
          <div className="flex-1 flex flex-col items-center justify-center">
            <h2 className="text-white text-xl lg:text-6xl font-thin">
              Thank you!
            </h2>
          </div>
        </div>

        <div className="w-100 min-h-screen bg-gradient-to-b to-black from-gray-1400 relative pt-12 pb-12">
          <div className="container text-white mx-auto p-6">
            <p className="text-white text-left text-xl lg:text-3xl font-thin mt-6">
              Thank you for your order. Your ticket numbers have been emailed to
              you and are also listed below.
            </p>
            <p className="text-white text-left text-xl lg:text-3xl font-thin mt-6">
              We will be in touch if you win a prize!
            </p>
            <p className="text-white text-left text-xl lg:text-3xl font-thin mt-6">
              Good luck!
            </p>

            <p className="text-white text-left text-xl lg:text-3xl font-bold mt-12">
              Your ticket numbers:
            </p>
            {!this.state.tickets && (
              <FontAwesomeIcon className="text-4xl" icon={faSpinner} spin />
            )}
            <div className="flex flex-row flex-wrap">
              {this.state.tickets &&
                this.state.tickets.map((t) => (
                  <div key={`t${t.ticketId}`} className="ticket">
                    <div
                      className="ticket--number text-3xl mr-4"
                      data-number={t.ticketId}
                    >
                      {t.ticketId}
                    </div>
                  </div>
                ))}
            </div>

            <p className="text-white text-left text-xl lg:text-3xl font-thin mt-6 mb-6">
              Why not tell your friends and family about the raffle?
            </p>
            <div>
              <FacebookShareButton
                className="mr-3"
                url="https://uptonprioryraffle.com"
              >
                <FacebookIcon size={64} round />
              </FacebookShareButton>
              <EmailShareButton
                className="mr-3"
                url="https://uptonprioryraffle.com"
              >
                <EmailIcon size={64} round />
              </EmailShareButton>
              <TwitterShareButton
                className="mr-3"
                url="https://uptonprioryraffle.com"
              >
                <TwitterIcon size={64} round />
              </TwitterShareButton>
              <WhatsappShareButton
                className="mr-3"
                url="https://uptonprioryraffle.com"
              >
                <WhatsappIcon size={64} round />
              </WhatsappShareButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ data }) => ({
  data,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Success)
);
